import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { useMutation, gql } from '@apollo/client';

const CONFIRM_EMAIL = gql`
  mutation confirmEmail($activationToken: String!) {
    confirmEmail(activationToken: $activationToken)
  }
`;

const StyledContainer = styled.div`
  margin-top: 20px;
  align-self: flex-start;
`;

const Content = styled.div`
  margin-bottom: 20px;
`;

function ConfirmEmail() {
  const { pageType } = useConfirmEmailState();

  if (pageType === 'loading') {
    return (
      <StyledContainer>
        <div>Bitte warten</div>
      </StyledContainer>
    );
  }

  if (pageType === 'success') {
    return (
      <StyledContainer>
        <Content>Die E-Mail Adresse wurde erfolgreich bestätigt.</Content>
        <BackToLogin />
      </StyledContainer>
    );
  }

  if (pageType === 'error') {
    return (
      <StyledContainer>
        <Content>
          Dieser Link ist ungültig oder wurde bereits verwendet.
        </Content>
        <BackToLogin />
      </StyledContainer>
    );
  }

  return null;
}

function useConfirmEmailState() {
  const [pageType, setPageType] = useState('loading');
  const { activationToken } = useParams();
  const [confirmEmail] = useMutation(CONFIRM_EMAIL);

  // console.log(activationToken);

  useEffect(() => {
    async function run() {
      try {
        await confirmEmail({
          variables: {
            activationToken,
          },
        });
        // console.log(result);
        setPageType('success');
      } catch (error) {
        console.log(error);
        setPageType('error');
      }
    }
    run();
  }, [activationToken, confirmEmail]);

  return { pageType };
}

const BackToLogin = () => (
  <div>
    Klicke <Link to={`/login`}>hier</Link>, um zur Anmeldung zu gelangen.
  </div>
);

export default ConfirmEmail;
